import PayrollEmployeePage from "../PayrollEmployeePage.vue";
import PayrollManagerPage from "../PayrollManagerPage.vue";
import PayrollAdminPage from "../PayrollAdminPage.vue";
import PTPayrollComponent from "../PTPayrollComponent.vue";

export default [
  {
    path: "/payroll",
    name: "Payroll",
    meta: { layout: "default" },
    component: PayrollEmployeePage,
  },
  {
    path: "/payroll/manage",
    name: "PayrollManager",
    meta: { layout: "default" },
    component: PayrollManagerPage,
  },
  {
    path: "/payroll/admin",
    name: "PayrollAdmin",
    meta: { layout: "default" },
    component: PayrollAdminPage,
  },
  {
    path: "/payroll/pt",
    name: "PTPayroll",
    meta: { layout: "default" },
    component: PTPayrollComponent,
  },
];
